module.exports = __webpack_public_path__ + "static/media/MAE_APP_LOGO.c3658443.png";